import { FormControl, FormGroup } from '@angular/forms';
import { TypographyStyleConfigurations } from '@finxone-platform/shared/sys-config-types';
import { renameFormGroupControl, reorderFormGroupControls } from './global-theme-form-group-reorder.utils';

export function buildTypographyStyleFormGroup(styles?: Partial<TypographyStyleConfigurations>): FormGroup {
  return new FormGroup({
    'font-family': new FormControl(styles?.['font-family'] ?? ''),
    'font-weight': new FormControl(styles?.['font-weight'] ?? ''),
    'text-decoration': new FormControl(styles?.['text-decoration'] ?? ''),
    'font-size': new FormControl(styles?.['font-size'] ?? ''),
    'letter-spacing': new FormControl(styles?.['letter-spacing'] ?? ''),
    'line-height': new FormControl(styles?.['line-height'] ?? ''),
    'margin-bottom': new FormControl(styles?.['margin-bottom'] ?? ''),
  });
}

/** Adds a new custom-named typography style as a sibling control on the typography FormGroup. */
export function addCustomTypographyStyle(
  typographyFormGroup: FormGroup,
  styleName: string,
  defaults?: Partial<TypographyStyleConfigurations>,
): void {
  typographyFormGroup.addControl(styleName, buildTypographyStyleFormGroup(defaults));
}

/** Renames a custom typography style in place, keeping its position among its siblings. */
export function renameCustomTypographyStyle(
  typographyFormGroup: FormGroup,
  oldName: string,
  newName: string,
): void {
  renameFormGroupControl(typographyFormGroup, oldName, newName);
}

/** Reorders typography styles, driven by PrimeNG's row-reorder drag/drop indices. */
export function reorderTypographyStyle(
  typographyFormGroup: FormGroup,
  fromIndex: number,
  toIndex: number,
): void {
  reorderFormGroupControls(typographyFormGroup, fromIndex, toIndex);
}

/** Removes a custom typography style from the typography FormGroup. */
export function removeCustomTypographyStyle(typographyFormGroup: FormGroup, styleName: string): void {
  typographyFormGroup.removeControl(styleName);
}
